import React from 'react';

const TopicFilter = ({ selectedTopic, onTopicChange }) => {
  const topics = [
    { value: 'all', label: 'All Topics' },
    { value: 'personal_finance', label: 'Personal Finance' },
    { value: 'investment_tips', label: 'Investment Tips' },
    { value: 'budgeting_strategies', label: 'Budgeting' },
    { value: 'market_analysis', label: 'Market Analysis' },
    { value: 'credit_management', label: 'Credit' },
    { value: 'debt_management', label: 'Debt Management' },
    { value: 'saving_strategies', label: 'Saving' },
    { value: 'financial_wellness', label: 'Wellness' }
  ];

  return (
    <div className="flex flex-wrap gap-8">
      {topics?.map((topic) => (
        <button
          key={topic?.value}
          onClick={() => onTopicChange(topic?.value)}
          className={`px-16 py-8 rounded-lg text-sm font-medium transition-colors ${
            selectedTopic === topic?.value
              ? 'bg-primary text-primary-foreground'
              : 'bg-card text-muted-foreground hover:bg-muted border border-border'
          }`}
        >
          {topic?.label}
        </button>
      ))}
    </div>
  );
};

export default TopicFilter;